import React from 'react'
import { Link } from 'react-router-dom'

const HowItWorks = () => {
    const workData = [
        {
            id: 1,
            title: "Reserve your dates",
            subtitle: "Place the required deposit."
        },
        {
            id: 2,
            title: "Complete the docs.",
            subtitle: "Click to sign completely online."
        },
        {
            id: 3,
            title: "Arrive for your stay.",
            subtitle: "Once you arrive we will check you in and show you around."
        }
    ];
    
    return (
        <section className="flex flex-col items-center py-12 lg:py-16 bg-[#fafafa]">
            <div className="text-center lg:mb-8">
                <h1 className="text-[28px] md:text-[36px] font-semibold text-[#000] leading-[100%] mb-8 lg:mb-20">How do I stay?</h1>
            </div>
            <div className="container mx-auto px-4">
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 md:gap-12">
                {workData.map((work, index) => (
                    <div key={index} className="flex flex-col items-center text-center gap-3">
                        <p className='font-semibold'>Step {" "} {work.id}</p>
                        <h3 className="text-[18px] md:text-xl font-semibold text-[#1b1b1b]">{work.title}</h3>
                        <p className="mt-2 text-[#757575] text-[16px] md:text-[16px] font-light px-4">{work.subtitle}</p>
                    </div>
                ))}
                </div>
            </div>
            <Link to="/locations/nyc"><button className='bg-[#1b1b1b] text-white rounded-full px-10 md:px-16 py-3.5 md:py-4 text-[14px] md:text-[18px] font-medium mt-6 lg:mt-12'>Stay</button></Link>
        </section>
    )
}

export default HowItWorks